import React, { Component } from 'react';


import Grid from '@material-ui/core/Grid';
import DownIcon from '@material-ui/icons/ArrowDownward';
import UpIcon from '@material-ui/icons/ArrowUpward';

import GaugeDraw from './../../Dashboard/graphics/components/ChartGaugeDashboard/GaugeDraw';

import './../../Dashboard/graphics/components/ChartGaugeDashboard/gaugeStyle.css';


class GaugeComponent extends Component {

  getFenomeno = (name) => {
    switch (name) {
      case 'gauges_homicidios': return { id: 1, name: 'Homicidios' }
      case 'gauges_h_Personas': return { id: 2, name: 'Hurto a personas' }
      case 'gauges_h_celulares': return { id: 3, name: 'Hurto de celulares' }
      case 'gauges_h_vehiculos': return { id: 4, name: 'Hurto de vehículos' }
      case 'gauges_h_motocicletas': return { id: 5, name: 'Hurto de motocicletas' }
      case 'gauges_h_comercio': return { id: 6, name: 'Hurto a comercios' }
      case 'gauges_h_residencias': return { id: 7, name: 'Hurto a residencias' }
      case 'gauges_delito_sexuales': return { id: 8, name: 'Delitos sexuales' }
      case 'gauges_incautacion_armas': return { id: 9, name: 'Incautación de armas de fuego' }
      case 'gauges_incautacion_estupefacientes': return { id: 10, name: 'Incautación de estupefacientes' }
      case 'gauges_recuperacion_vehiculos': return { id: 11, name: 'Recuperación de vehículos' }
      case 'gauges_recuperacion_motocicletas': return { id: 12, name: 'Recuperación de motocicletas' }
      case 'gauges_violencia_intrafamiliar': return { id: 15, name: 'Violencia intrafamiliar' }
      case 'gauges_lesiones_personales': return { id: 16, name: 'Lesiones personales' }
      case 'gauges_capturas': return { id: 37, name: 'Capturas' }
      // case '': return {id: ,name:''}
      default: return { id: 0, name: '' }
    }

  }

  getAngle = () => {
    let all = this.props.data;
    let hoy = new Date();
    let angle = 0;
    all.map((cv) => {
      if (cv.name === (hoy.getFullYear() - 1).toString())
        angle = cv.value
      return true
    });
    return angle;
  }
  getColor = (val) => {
    let all = this.props.data;
    if (this.props.group.includes('ope') || this.props.group.includes('ep')) {
      if (val === all[0].name) {
        try {
          if (all[0].value > all[1].value)
            return 'green'
          return 'red'
        } catch (e) { return 'green' }
      }
    }
    try {
      if (val === all[0].name) {
        try {
          if (all[0].value > all[1].value)
            return 'red'
          return 'green'
        } catch (e) { return 'red' }
      }
    } catch (e) { }

    return '#555';
  }

  getData = () => {
    let all = this.props.data;
    let resp = [];
    try {
      resp.push({ value: all[1].value, color: '#555' });
      resp.push({ value: (all[0].value > all[1].value * 1.5) ? all[0].value : all[1].value * 0.5, color: '#ccc' });
    } catch (e) {
      resp.push({ value: all[0].value, color: '#ccc' });
    }
    return resp;
  }

  getColorGauge = () => {
    // let title = this.props.name.toLowerCase();
    if (this.props.group.includes('ope') || this.props.group.includes('ep')) {
      try {
        if (this.props.data[0].value <= this.props.data[1].value)
          return 'red';
      } catch (e) { }
      return 'green';
    }
    try {
      if (this.props.data[0].value <= this.props.data[1].value)
        return 'green';
    } catch (e) { }
    return 'red';
  }

  getPercent = () => {
    try {
      let all = this.props.data;
      let mayor = all.reduce((tot, cv) => ((tot.value > cv.value) ? tot : cv));
      let menor = all.reduce((tot, cv) => ((tot.value < cv.value) ? tot : cv));
      let hoy = parseInt(all[0].name);
      if (hoy === parseInt(mayor.name)) {
        //Aumento
        if (this.props.group.includes('ope') || this.props.group.includes('ep')) {
          return (
            <p style={{ color: 'green', }}>
              {parseInt((1 - menor.value / mayor.value) * 100) + '%'}
              <UpIcon />
            </p>
          )
        }
        return (
          <p style={{ color: 'red', }}>
            {parseInt((1 - menor.value / mayor.value) * 100) + '%'}
            <UpIcon />
          </p>
        )
      } else {
        if (this.props.group.includes('ope') || this.props.group.includes('ep')) {
          return (
            <p style={{ color: 'red', }}>
              {parseInt((1 - menor.value / mayor.value) * 100) + '%'}
              <DownIcon />
            </p>
          )
        }
        return (
          <p style={{ color: 'green', }}>
            {parseInt((1 - menor.value / mayor.value) * 100) + '%'}
            <DownIcon />
          </p>
        )
      }
    } catch (e) {
      return (
        <p style={{ color: 'green' }}>
          {'0%'}
          <DownIcon />
        </p>
      )
    }
  }

  onClick = () => {
    try {
      this.props.onClickGraphic(this.props.name, this.getFenomeno(this.props.name));
    } catch (e) { }
  }

  render() {
    const { name, data } = this.props;
    try {

      return (
        <Grid container id={this.props.name}>
          <Grid container>
            <Grid item xs={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {
                data.map((val, index) => {
                  return <p style={{ textAlign: 'none', color: this.getColor(val.name), fontWeight: 'bold', marginLeft: '10px' }} key={'p-gauge-' + name + index}>{val.name + ': ' + val.value}</p>
                })
              }
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {
                this.getPercent()
              }
            </Grid>
            <Grid item xs={12} className="client-label" style={{ textAlign: 'center' }}>
              <GaugeDraw
                angleValue={this.props.data[0].value}
                colorGauge={this.getColorGauge()}
                data={this.getData()}
                // onClickGraphic={this.onClick}
                name={name}
                dataDev={data}
              />
            </Grid>
          </Grid>
        </Grid>
      )
    } catch (e) {
      const ya = new Date();
      const gaugeData = [
        { value: 0, color: 'green' },
        { value: 1, color: '#ccc' }
      ]
      return (
        <Grid container id={this.props.name}>
          <Grid container>
            <Grid item xs={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
              <p style={{ textAlign: 'none', color: "green", fontWeight: 'bold', marginLeft: '10px' }} >{ya.getFullYear() + ': 0'}</p>
              <p style={{ textAlign: 'none', color: "#555", fontWeight: 'bold', marginLeft: '10px' }} >{(ya.getFullYear() - 1) + ': 0'}</p>
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
              <p style={{ color: 'green', }}>
                {'0%'}
                <DownIcon />
              </p>
            </Grid>
            <Grid item xs={12} className="client-label" style={{ textAlign: 'center' }}>
              <GaugeDraw
                angleValue={0}
                colorGauge="green"
                data={gaugeData}
                name={name}
                dataDev={gaugeData}
              />
            </Grid>
          </Grid>
        </Grid>
      )
    }
  }
}

export default GaugeComponent; 